
export const setLocalStorage = (key: string, item: any) => {
	localStorage.setItem(key, item);
};

export const getLocalStorage = (item: any) => {
	// if(item === 'token'){
	// 	return decodeURI(getCookie('token'));
	// }else{
	// 	return localStorage.getItem(item) ? localStorage.getItem(item) : ''
	// }
	return localStorage.getItem(item) ? localStorage.getItem(item) : '';
};

export const clearLocalStorage = () => {
	document.cookie = "token=;path=/;Max-Age=0;expires"+new Date();
	localStorage.clear();
};


function getCookie(cname:string) {
	let name = cname + "=";
	let ca = document.cookie.split(';');
	for(let i = 0; i < ca.length; i++) {
	  let c = ca[i];
	  while (c.charAt(0) === ' ') {
		c = c.substring(1);
	  }
	  if (c.indexOf(name) === 0) {
		return c.substring(name.length, c.length);
	  }
	}
	return "";
  }
  
